import { Link } from "react-router-dom";
import Button, { ButtonType } from "../../../../components/Button/Button";
import Pencil from "../../../../assets/pencil";
import { Address, OrderSplitCurrentOrder } from "../../../../interfaces/interfaces";
import { FreightOption } from "../../../../interfaces/types";
import { formatFreightOption } from "./util";
import { renderPaymentMethod } from "../../payment-selection/sendPaymentSelection";

interface Props {
  currentOrder: OrderSplitCurrentOrder;
  currentOrderShipAddress: Address | null;
  extraInfo: any;
  freightOption: FreightOption;
  customerCOD: boolean;
}

const ClientInformation = ({
  currentOrder,
  currentOrderShipAddress,
  extraInfo,
  freightOption,
  customerCOD,
}: Props) => {
  return (
    <>
      <div className="client-information-header">
        <h3>Customer Information</h3>
      </div>
      <div className="order-details-container">
        <div className="info-section">
          <div className="info-content">
            <table>
              <tbody>
                <tr>
                  <th>PO Number</th>
                  <td>{extraInfo.po_number}</td>
                </tr>
                <tr>
                  <th>Created By</th>
                  <td>{localStorage.getItem("email")}</td>
                </tr>
                {extraInfo.comments ? (
                  <tr>
                    <th>Comments</th>
                    <td>{extraInfo.comments}</td>
                  </tr>
                ) : null}
                {extraInfo.associated_email ? (
                  <tr>
                    <th>Associated Email</th>
                    <td>{extraInfo.associated_email}</td>
                  </tr>
                ) : null}
              </tbody>
            </table>
          </div>
          <div className="edit-button-container">
            <Link replace to="/check-out/extra-info">
              <Button type={ButtonType.secondary} className="edit-button">
                <Pencil width={13} height={13} />
                Edit
              </Button>
            </Link>
          </div>
        </div>

        <div className="divider" />

        <div className="info-section">
          <div className="info-content">
            <table>
              <tbody>
                <tr>
                  <th>Shipping Method</th>
                  <td>{formatFreightOption(freightOption)}</td>
                </tr>
                <tr>
                  <th>Ship To</th>
                  <td>{currentOrderShipAddress?.ship_to_name}</td>
                </tr>
                <tr>
                  <th>Shipping Address</th>
                  <td>
                    <div>{formatAddress(currentOrderShipAddress)}</div>
                    <div>
                      {/* Labelling to fix halfback problem later */}
                      {currentOrderShipAddress?.state} {currentOrderShipAddress?.address_postcode}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="edit-button-container">
            <Link replace to="/check-out/shipping-selection">
              <Button type={ButtonType.secondary} className="edit-button">
                <Pencil width={13} height={13} />
                Edit
              </Button>
            </Link>
          </div>
        </div>

        {customerCOD && (
          <>
            <div className="divider" />
            <div className="info-section">
              <div className="info-content">
                <table>
                  <tbody>
                    <tr>
                      <th>Payment Method</th>
                      <td>{renderPaymentMethod[currentOrder.payment_method]}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="edit-button-container">
                <Link replace to="/check-out/payment-selection">
                  <Button type={ButtonType.secondary} className="edit-button">
                    <Pencil width={13} height={13} />
                    Edit
                  </Button>
                </Link>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

const formatAddress = (currentOrderShipAddress: Address | null) => {
  if (!currentOrderShipAddress) {
    return "";
  }

  const { address_line1, address_line2, address_line3, address_line4, address_city } =
    currentOrderShipAddress;
  let address = "";

  if (address_line1) {
    address += address_line1;
  }
  if (address_line2) {
    address += `, ${address_line2}`;
  }
  if (address_line3) {
    address += `, ${address_line3}`;
  }
  if (address_line4) {
    address += `, ${address_line4}`;
  }
  if (address_city) {
    address += `, ${address_city}`;
  }
  return address;
};

export default ClientInformation;
